import type {
  TlaPlanningDemandDetailRow,
  TlaPlanningQtyOrderedDetailRow,
  TlaPlanningSupplyDetailRow,
} from "./tlaPlanningShared";

const TLA_PLANNING_OVERVIEW_SESSION_CACHE_KEY = "mrp-tla-planning-overview:v3";
const TLA_PLANNING_OVERVIEW_SESSION_CACHE_AT_KEY = "mrp-tla-planning-overview:at:v3";

export interface TlaPlanningOverviewSessionCachePayload {
  rows: Array<{
    effective_location_id: number;
    location_name: string;
    sku: string;
    total_remaining_build_capacity: number;
    pending_sales_quantity: number;
    additional_build_orders_needed: number;
    remaining_after_pending_sales: number;
    net_remaining: number;
    reorder_to: number;
    amount_to_order: number;
  }>;
  line_details: {
    supply_by_key: Record<string, TlaPlanningSupplyDetailRow[]>;
    demand_by_key: Record<string, TlaPlanningDemandDetailRow[]>;
    qty_ordered_by_key: Record<string, TlaPlanningQtyOrderedDetailRow[]>;
  };
}

export function readTlaPlanningOverviewSessionCache(): TlaPlanningOverviewSessionCachePayload | undefined {
  try {
    const raw = sessionStorage.getItem(TLA_PLANNING_OVERVIEW_SESSION_CACHE_KEY);
    if (raw == null || raw.trim() === "") return undefined;
    const parsed = JSON.parse(raw) as TlaPlanningOverviewSessionCachePayload;
    if (!Array.isArray(parsed.rows) || parsed.line_details == null) return undefined;
    if (
      typeof parsed.line_details.supply_by_key !== "object" ||
      typeof parsed.line_details.demand_by_key !== "object" ||
      typeof parsed.line_details.qty_ordered_by_key !== "object"
    ) {
      return undefined;
    }
    return parsed;
  } catch {
    return undefined;
  }
}

export function readTlaPlanningOverviewSessionCacheUpdatedAt(): number {
  try {
    const raw = sessionStorage.getItem(TLA_PLANNING_OVERVIEW_SESSION_CACHE_AT_KEY);
    if (raw == null || raw.trim() === "") return 0;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : 0;
  } catch {
    return 0;
  }
}

export function writeTlaPlanningOverviewSessionCache(payload: TlaPlanningOverviewSessionCachePayload): void {
  try {
    sessionStorage.setItem(TLA_PLANNING_OVERVIEW_SESSION_CACHE_KEY, JSON.stringify(payload));
    sessionStorage.setItem(TLA_PLANNING_OVERVIEW_SESSION_CACHE_AT_KEY, String(Date.now()));
  } catch {
    // sessionStorage may be unavailable or full
  }
}
